/**
 * @Description 组件  验证码
 * @Author cc
 * @Time 2021/06/01
 */

<template>
	<div
		class="ValidCode disabled-select"
		:style="initStyle()"
		@click="refreshCode"
		onselectstart="return false"
		>
		<span
			v-for="(item, index) in codeList"
			:key="index"
			:style="getStyle(item)"
			>{{ item.code }}</span>
	</div>
</template>

<script>
	export default {
		name: 'ValidCode',
		model: {
			prop: 'value',
			event: 'input'
		},
		props: {
			width: {
				type: String,
				default: '100px'
			},
			height: {
				type: String,
				default: '40px'
			},
			length: {
				type: Number,
				default: 4
			},
			refresh: {
				type: Number
			},
			autoSty: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				codeList: []
			}
		},
		watch: {
			refresh () {
				this.createdCode()
			}
		},
		mounted () {
			this.createdCode()
		},
		methods: {
			refreshCode () {
				this.createdCode()
			},
			createdCode () {
				const len = this.length
				const codeList = []
				const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789'
				const charsLen = chars.length
				// 生成
				for (let i = 0; i < len; i++) {
					const rgb = [Math.round(Math.random() * 220), Math.round(Math.random() * 240), Math.round(Math.random() * 200)]
					codeList.push({
						code: chars.charAt(Math.floor(Math.random() * charsLen)),
						color: `rgb(${rgb})`,
						fontSize: `${10 + (+[Math.floor(Math.random() * 10)] + 6)}px`,
						padding: `${[Math.floor(Math.random() * 10)]}px`,
						transform: `rotate(${Math.floor(Math.random() * 90) - Math.floor(Math.random() * 90)}deg)`
					})
				}
				codeList.unshift({code: ''});
				codeList.push({code: ''});
				// 指向
				this.codeList = codeList
				// 将当前数据派发出去
				//console.log(codeList.map(item => item.code).join(''))
				this.$emit('input', codeList.map(item => item.code).join(''))
			},
			getStyle (data) {
				if (!this.autoSty) return '';
				return `color: ${data.color}; font-size: ${data.fontSize}; padding: ${data.padding}; transform: ${data.transform}`
			},
			initStyle () {
				return `width:${this.width}; height:${this.height};`;
			}
		}
	}
</script>

<style scoped lang="scss">
	.ValidCode{
		display: flex;
		/*justify-content: center;*/
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
		color: #fff;
		/*font-weight: bold;*/
		font-size: 24px;
		
		overflow: hidden;
		line-height: normal;
		
		span {
			display: inline-block;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/ValidCode/ValidCode.vue